import React, { useState } from 'react';

const KovExample = ({ item, color, children }) => {
  return (<></>)
  throw new Error('Example content block component is empty. You need a custom version of it.');
};

export default KovExample;
